import { render, staticRenderFns } from "./QuizTimeAnswerText.vue?vue&type=template&id=08422d75&scoped=true&"
import script from "./QuizTimeAnswerText.vue?vue&type=script&lang=js&"
export * from "./QuizTimeAnswerText.vue?vue&type=script&lang=js&"
import style0 from "./QuizTimeAnswerText.vue?vue&type=style&index=0&id=08422d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08422d75",
  null
  
)

export default component.exports